import { Text, TextProps } from '@rbilabs/universal-components';
import { View } from 'native-base';
import { useIntl } from 'react-intl';

import { DISABLE_STORE_CHANGE_DIALOG } from 'state/store/constants';

interface Props extends TextProps {}

export const StoreChangeDisclaimer = (props: Props) => {
  const { formatMessage } = useIntl();

  if (DISABLE_STORE_CHANGE_DIALOG) {
    return (
      <View>
        <Text fontSize="xs" {...props}>
          {formatMessage({ id: 'changingYourStoreDisclaimer' })}
        </Text>
      </View>
    );
  }
  return null;
};
